// extracted by mini-css-extract-plugin
module.exports =  {"material-input-wrapper":"material_modal__material-input-wrapper___Up2Lh","materialInputWrapper":"material_modal__material-input-wrapper___Up2Lh"};